import React, { useEffect, useCallback, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Button,
  Box,
  Link,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
// import AddNewPolicy from "../../../../Components/Broker/Policies/AddNewPolicy/AddNewPolicy";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import AddNewPolicy from "../../../../Components/Broker/Policies/AddNewPolicySP/AddNewPolicy";
import BulkUploadForm from "../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";

interface Props {
  addPolicy: boolean;
}

const Policies: React.FC<Props> = ({ addPolicy }) => {
  const [addCdBalance, setAddCdBalance] = React.useState(false);
  const [addFilterStatus, setAddFilterStatus] = React.useState(false);
  const [editPolicy, setEditPolicy] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [addNewPolicy, setAddNewPolicy] = React.useState(false);
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [addNewEmployeeStep, setAddNewEmployeeStep] = React.useState(1);
  const [cdAmount, setCdAmount] = React.useState("");
  const [policyname, setPolicyName] = React.useState("");
  const [expiry, setExpiryStatus] = React.useState("");
  const [age, setAge] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [policyid, setPolicyId] = React.useState("");
  const [clientid, setClientId] = React.useState("");
  const [policytype, setPolicyType] = React.useState("");
  const [insurer, setInsurer] = React.useState("");
  const [nol, setNol] = React.useState("");
  const [dependent, setDependent] = React.useState("");
  const [policyno, setPolicyNo] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [cdbalance, SetCdBalance] = React.useState("");
  const [activelives, setActiveLives] = React.useState("");
  const [activedependents, setActiveDependents] = React.useState("");
  const [features, setFeatures] = React.useState("");
  const [premium, setPremium] = React.useState("");
  const [location, setLocation] = React.useState("");
  const navigate = useNavigate();

  // useEffect(() => {
  //   // attach the event listener
  //   window.addEventListener("keydown", handleKeyPress);
  // }, []);

  // const handleKeyPress = useCallback((e: any) => {
  //   var event = e;
  //   if (event.target.tagName !== "INPUT") {
  //     if (event.shiftKey && event.keyCode == 80) {
  //       setAddPolicyStatus(true);
  //     }
  //   }
  // }, []);

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "policy_id",
      headerName: "Policy ID",
      width: 170,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/PolicyDetail?product_type=" + row.policy_type);
            }}
          >
            EPZ08665R56456
          </Link>
        );
      },
    },
    {
      field: "client_name",
      headerName: "Client Name",
      width: 220,
      check_status: true,
    },
    {
      field: "client_id",
      headerName: "Client ID",
      width: 150,
      check_status: true,
    },
    {
      field: "policy_type",
      headerName: "Policy Type",
      width: 200,
      check_status: true,
    },
    {
      field: "insurer",
      headerName: "Insurer",
      width: 180,
      check_status: true,
    },
    {
      field: "policynumber",
      headerName: "Policy Number",
      width: 180,
      check_status: true,
    },
    {
      field: "start_date",
      headerName: "Policy Start Date",
      width: 130,
      check_status: true,
    },
    {
      field: "end_date",
      headerName: "Policy End Date",
      width: 130,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "nol",
      headerName: "No.of Lives",
      width: 100,
      check_status: true,
    },
    {
      field: "noe",
      headerName: "No. of Employees",
      width: 150,
      check_status: true,
    },
    {
      field: "sum_assured",
      headerName: "Sum Insured/Assured",
      width: 180,
      check_status: true,
    },
    {
      field: "cdbal",
      headerName: "CD Balance",
      width: 130,
      check_status: true,
    },
    {
      field: "premium",
      headerName: "Premium",
      width: 130,
      check_status: true,
    },
    {
      field: "branch_location",
      headerName: "Locations",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 1,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Super Top-up Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 2,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 3,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 4,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 5,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 6,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 7,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 8,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹10,50,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
    {
      id: 9,
      policy_id: "EV234234234",
      client_name: "Evervent",
      client_id: "EV3234",
      policy_type: "Group Health Policy",
      insurer: "Reliance",
      policynumber: "KF55859FD86",
      nol: "1205",
      noe: "600",
      policy_number: "BG234234HGFG",
      start_date: "22-02-2022",
      end_date: "22-02-2023",
      status: "Active",
      cdbal: "₹10,50,234",
      premium: "₹35,234",
      sum_assured: "2L, 3L, 5L",
      branch_location: "Mumbai, Chandigarh",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Grid container spacing={2}>
      {/* Bulk upload */}
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />

      {/* add cd balance popup */}
      <Modal open={addCdBalance} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={2}>
            <Grid item xs={12} className="mb-4">
              <Link
                className="close-button"
                onClick={() => {
                  setAddCdBalance(false);
                }}
              />
              <h5 className="popup-heading">Add CD Balance</h5>
            </Grid>
          </Grid>
          {addNewEmployeeStep == 1 ? (
            <div>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                className="mb-4"
              >
                <Grid item xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Enter CD Amount"}
                    value={cdAmount}
                    attrName={setCdAmount}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center" }}
                  className="ctaBtn"
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => setAddCdBalance(false)}
                  >
                    Add Amount
                  </Button>
                </Grid>
              </Grid>
            </div>
          ) : null}
          {addNewEmployeeStep == 2 ? (
            <Grid item xs={12}>
              <Link className="md-link" underline="none">
                Great ! New Employee added.
              </Link>
            </Grid>
          ) : null}
        </Box>
      </Modal>

      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">Policies</h3>
        <SearchBox />
      </Grid>
      <Grid item xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        <Link
          underline="none"
          className="blueBtn download"
          onClick={() => setUploadFile(true)}
        >
          CSV
        </Link>

        <Link
          underline="none"
          className="blueBtn edit"
          onClick={() => {
            // setEditPolicy(true);
          }}
        >
          Edit
        </Link>
        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            navigate("/AddNewPolicy");
          }}
        >
          Add Policy
        </Link>
      </Grid>
      <Grid item xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Policies;
